<fieldset>
  <div class="content brief">
    <field-label [field]="field" [notRequired]="true"></field-label>

    <field-value [field]="field" emptyMessage="This field has not been set yet">
      @for (msg of messages; track msg) {
      <div>{{ msg }}</div>
      }
    </field-value>

    @if (!disabled) {
    <div class="edit">
      <a [routerLink]="editLink">edit</a>
    </div>
    }
  </div>
</fieldset>
